/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ObserversModule} from '@angular/cdk/observers';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollDispatchModule, VIEWPORT_RULER_PROVIDER} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MdCommonModule, MdRippleModule} from '@angular/material/core';
import {MdInkBar} from './ink-bar';
import {MdTab} from './tab';
import {MdTabBody} from './tab-body';
import {MdTabGroup} from './tab-group';
import {MdTabHeader} from './tab-header';
import {MdTabLabel} from './tab-label';
import {MdTabLabelWrapper} from './tab-label-wrapper';
import {MdTabLink, MdTabNav} from './tab-nav-bar/tab-nav-bar';
export class MdTabsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdCommonModule,
    PortalModule,
    MdRippleModule,
    ObserversModule,
    ScrollDispatchModule,
  ],
  // Don't export all components because some are only to be used internally.
  exports: [
    MdCommonModule,
    MdTabGroup,
    MdTabLabel,
    MdTab,
    MdTabNav,
    MdTabLink,
  ],
  declarations: [
    MdTabGroup,
    MdTabLabel,
    MdTab,
    MdInkBar,
    MdTabLabelWrapper,
    MdTabNav,
    MdTabLink,
    MdTabBody,
    MdTabHeader
  ],
  providers: [VIEWPORT_RULER_PROVIDER],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdTabsModule_tsickle_Closure_declarations() {
/** @type {?} */
MdTabsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdTabsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
